export default function Footer() {
  return (
    <footer id="iletisim" className="bg-[#F5F5F5] border-t border-gray-200">
      {/* CTA Band */}
      <div className="bg-[#2B2B2B] py-20 px-6">
        <div className="max-w-[1200px] mx-auto text-center">
          <p className="text-[#A66A3F] text-xs font-semibold tracking-[0.2em] uppercase mb-4">Projeniz İçin</p>
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4 leading-tight">
            Prefabrike Enerji Depolama<br className="hidden md:block" /> Çözümleri
          </h2>
          <p className="text-white/50 text-base mb-8 max-w-lg mx-auto">
            Projenize özel mühendislik çözümü için bizimle iletişime geçin.
          </p>
          <a
            href="/iletisim"
            className="inline-flex items-center gap-3 px-8 py-3.5 bg-[#A66A3F] text-white text-sm font-semibold hover:bg-[#8f5a33] transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-mail-line" />
            İletişime Geç
          </a>
          <p className="text-white/30 text-sm mt-6">www.aksess.com.tr</p>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="max-w-[1200px] mx-auto px-6 py-8 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-4">
          <img
            src="https://static.readdy.ai/image/ecb21a4bf5131aa1974d0073377f0964/747df155e81b0da5fc194fc4a2f96f93.png"
            alt="AKSESS"
            className="h-7 w-auto object-contain opacity-70"
          />
          <span className="text-xs text-gray-400">© 2024 AKSESS Energy Systems. Tüm hakları saklıdır.</span>
        </div>
        <div className="flex items-center gap-6">
          {["Ürünler", "Çözümler", "İletişim"].map((link) => (
            <a key={link} href="#" className="text-xs text-gray-400 hover:text-[#A66A3F] transition-colors cursor-pointer whitespace-nowrap">
              {link}
            </a>
          ))}
        </div>
      </div>

      {/* Design Credit */}
      <div className="border-t border-gray-200 py-3 px-6 text-center">
        <p className="text-xs text-gray-400">
          Web tasarımı{' '}
          <a
            href="https://www.ravocreative.com"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="text-[#A66A3F] hover:underline cursor-pointer whitespace-nowrap"
          >
            Ravo Creative Agency
          </a>
          {' '}tarafından tasarlanmıştır.
        </p>
      </div>
    </footer>
  );
}
